import DrawingBoard from './DrawingBoard';

export default DrawingBoard;


// WEBPACK FOOTER //
// ./src/components/DrawingBoard/index.js